module.exports = __webpack_public_path__ + "img/case3.31312ed7.png";